import styled from "styled-components";
import { colors } from "../../../../assets/styles";

export const Div = styled.div``;

export const ItemData = styled.span`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? colors.textColorBlackNine
      : colors.textColorBlackOne};
`;

export const Icon = styled.i`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? colors.textColorBlackNine
      : colors.textColorBlackFive};
`;
